import { Separator } from '@cocoonspace/ui/components/separator'
import { cn } from '@cocoonspace/ui/lib/utils'
import { useLingui } from '@lingui/react/macro'
import { LocalizedLink as Link } from '~/components/localized-link'

import { AxeptioButton } from './axeptio-button'
import { BaselineAndRating } from './baseline-and-rating'
import { Cocoon } from './cocoon'
import { FindUs } from './find-us'
import { Help } from './help'
import { Resources } from './resources'

// Evaluated once at module load (build/runtime), not during React render —
// avoids Cache Components prerender errors from `new Date()` in the render path.
const COPYRIGHT_YEAR = new Date().getFullYear()

const LegalAndSocial = () => {
	const { t } = useLingui()

	return (
		<div className='flex flex-col justify-between gap-4 md:flex-row'>
			<div className='text-center text-xs text-slate-500'>
				{`Copyright © ${COPYRIGHT_YEAR} Cocoon Space`}
			</div>

			<div className='flex flex-col items-center justify-center gap-4 md:flex-row'>
				<div className='flex flex-row gap-4 text-xs md:text-sm'>
					<AxeptioButton>{t`Paramètres des cookies`}</AxeptioButton>

					<Link
						className='hover:text-primary'
						href='/reglement-cocoon'
						target='_blank'
					>
						{t`Règles d'utilisations`}
					</Link>

					<Link
						className='hover:text-primary'
						href='/politique-confidentialite'
						target='_blank'
					>
						{t`Confidentialité`}
					</Link>

					<Link
						className='hover:text-primary'
						href='/mentions-legales'
						target='_blank'
					>
						{t`CGU`}
					</Link>
				</div>
			</div>
		</div>
	)
}

export const SiteFooter = ({ className }: { className?: string }) => (
	<footer className={cn('bg-white print:hidden', className)}>
		<div className='container flex flex-col gap-6 py-8'>
			<div className='flex flex-col gap-4 md:flex-row'>
				<BaselineAndRating />

				<div className='flex flex-col gap-4 md:ml-auto md:flex-row md:gap-[100px]'>
					<Cocoon />
					<FindUs />
					<Resources />
					<Help />
				</div>
			</div>

			<Separator />
			<LegalAndSocial />
		</div>
	</footer>
)
